import React, { useCallback, useEffect } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

import { Button } from '../..';
import hotKeyConverter from '../../../utility/keyCodeConverter';

type Props = ButtonProps & {
  resetHandler: () => void;
  withHotkey?: boolean;
  closeDialog?: () => void;
  closeOnCancel?: boolean;
};

const useStyles = makeStyles(({ palette }: Theme) => createStyles({
  root: {
    padding: 'unset',
    '&:hover': {
      backgroundColor: palette.cancelAction.background,
    },
  },
  disabled: palette.disabledButton,
}), { name: 'submit' });

const FormReset = ({
  resetHandler,
  children,
  withHotkey,
  closeDialog,
  ...props
}: Props) => {
  const styles = useStyles();

  useEffect(() => {
    const hotKeyHandler = (event: KeyboardEvent) => {
      if (event.keyCode === hotKeyConverter('esc')) {
        event.preventDefault();
        resetHandler();
      }
    };
    if (withHotkey) {
      window.addEventListener('keydown', hotKeyHandler);
    }
    return () => {
      if (withHotkey) {
        window.removeEventListener('keydown', hotKeyHandler);
      }
    };
  }, [withHotkey, resetHandler, closeDialog]);

  const onClickHandler = useCallback((e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (!e.defaultPrevented) {
      resetHandler();
    }

    if (closeDialog) {
      closeDialog();
    }
  }, [closeDialog, resetHandler]);

  return (
    <Button
      type="reset"
      onClick={onClickHandler}
      classes={{
        ...styles,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default FormReset;
